export const EVENT = {
  USER_LOGOUT: 'userLogout',
} as const;
